var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configuraciones-container"},[_c('h2',[_vm._v("Configuraciones")]),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Configuraciones del Sistema")])]),_c('div',[_vm._v(" Contenido de Configuraciones ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }